import Api from "./PreApiHandler";

export default {
    index,
    view,
    catalog,
    create,
    install,
    update,
    delete: actionDelete,
    publish,
    unpublish
};

async function index(params = {}) {
    const request = {
        method: 'get',
        path: 'report/user-dashboard/index',
        params
    }
    return Api.sendRequest(request)
}

async function view(uuid) {
    const request = {
        method: 'get',
        path: 'report/user-dashboard/view',
        params: { uuid }
    }
    return Api.sendRequest(request)
}

async function catalog() {
    const request = {
        method: 'get',
        path: 'report/user-dashboard/catalog'
    }
    return Api.sendRequest(request)
}

async function install(uuid, body = {}) {
    const request = {
        method: 'post',
        path: 'report/user-dashboard/install',
        params: { uuid },
        body
    }
    return Api.sendRequest(request)
}

async function create(body) {
    const request = {
        method: 'post',
        path: 'report/user-dashboard/create',
        body
    }
    return Api.sendRequest(request)
}

async function update(uuid, body) {
    const request = {
        method: 'post',
        path: 'report/user-dashboard/update',
        params: { uuid },
        body
    }
    return Api.sendRequest(request)
}

async function actionDelete(uuid) {
    const request = {
        method: 'post',
        path: 'report/user-dashboard/delete',
        params: { uuid }
    }
    return Api.sendRequest(request)
}

async function publish(uuid) {
    const request = {
        method: 'post',
        path: 'report/user-dashboard/publish',
        params: { uuid }
    }
    return Api.sendRequest(request)
}

async function unpublish(uuid) {
    const request = {
        method: 'post',
        path: 'report/user-dashboard/unpublish',
        params: { uuid }
    }
    return Api.sendRequest(request)
}
